module.exports = __webpack_public_path__ + "static/media/IMG_1881.1da56af8.JPG";